module.exports = __webpack_public_path__ + "img/mdb.ab31036d.svg";